import { connect } from 'react-redux';
import { getIsMobile, getSearchType, getTemplatesByOrg, getEmployerId } from '../../../modules/Settings';
import { getJobs, getTotalJobs, getLeaderboard, getError, getLoading, getLeaderboardMobile } from '../../../modules/JobsList';
import { getMetadata, getDisplayLocation, getPrimaryColor, getSecondaryColor, getNoAds, getExperiments } from '../../../modules/Filters';
import { jobSuffix } from '../../../app/helpers';
import { DISTANCE_UNITS_MAP } from '../../../app/helpers';
import { get, getCountry } from '../../../modules/I18n';
import Jobs from './Jobs';

const mapStateToProps = state => {
  const totalJobs = getTotalJobs(state);
  return {
    jobs: getJobs(state),
    loading: getLoading(state),
    totalJobs,
    isMobile: getIsMobile(state),
    displayLocation: getDisplayLocation(state),
    metadata: getMetadata(state),
    units: DISTANCE_UNITS_MAP[getCountry(state)],
    suffix: jobSuffix(totalJobs),
    leaderboard: getLeaderboard(state),
    leaderboardMobile: getLeaderboardMobile(state),
    error: getError(state),
    searchType: getSearchType(state),
    i18n: get(state),
    templatesByOrg: getTemplatesByOrg(state),
    employerId: getEmployerId(state),
    primaryColor: getPrimaryColor(state),
    secondaryColor: getSecondaryColor(state),
    noAds: getNoAds(state),
    experiments: getExperiments(state),
  };
};

const mapDispatchToProps = () => ({
  jobHovered: (id, entered) =>
    window && window.AJS &&
      typeof(window.AJS.highlightMarker) === 'function' &&
      window.AJS.highlightMarker(id, entered)
});

const JobsContainer = connect(mapStateToProps, mapDispatchToProps)(Jobs);

export default JobsContainer;
